import { motion } from 'framer-motion';
import { Shield, Star, AlertTriangle } from 'lucide-react';

export function BlogCoverCrisis() {
  return (
    <div className="w-full h-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-6 overflow-hidden relative">
      {/* Background grid pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }} />
      </div>
      
      {/* Glowing orb effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-primary/20 rounded-full blur-3xl" />
      
      {/* Smartphone mockup */}
      <motion.div 
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative z-10"
      >
        <div className="w-48 md:w-56 bg-slate-800 rounded-3xl p-2 shadow-2xl border border-slate-700/50">
          {/* Phone notch */}
          <div className="absolute top-4 left-1/2 -translate-x-1/2 w-16 h-4 bg-slate-900 rounded-full" />
          
          {/* Screen */}
          <div className="bg-white rounded-2xl p-3 min-h-[180px] md:min-h-[200px]">
            {/* Google Maps header simulation */}
            <div className="flex items-center gap-2 mb-3 pb-2 border-b border-slate-200">
              <div className="w-8 h-8 bg-slate-100 rounded-full flex items-center justify-center">
                <span className="text-xs font-bold text-slate-600">G</span>
              </div>
              <div className="flex-1">
                <div className="h-2 w-20 bg-slate-200 rounded" />
                <div className="h-1.5 w-14 bg-slate-100 rounded mt-1" />
              </div>
            </div>
            
            {/* Negative review */}
            <div className="space-y-2">
              <div className="flex items-center gap-1">
                <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />
                <Star className="w-3 h-3 text-slate-300" />
                <Star className="w-3 h-3 text-slate-300" />
                <Star className="w-3 h-3 text-slate-300" />
                <Star className="w-3 h-3 text-slate-300" />
              </div>
              <div className="space-y-1">
                <div className="h-1.5 w-full bg-slate-200 rounded" />
                <div className="h-1.5 w-3/4 bg-slate-200 rounded" />
                <div className="h-1.5 w-1/2 bg-slate-200 rounded" />
              </div>
            </div>
            
            {/* Warning indicator */}
            <div className="mt-3 flex items-center gap-1.5 text-amber-500">
              <AlertTriangle className="w-3 h-3" />
              <span className="text-[8px] font-medium">Avis critique détecté</span>
            </div>
          </div>
        </div>
        
        {/* Shield overlay - Protection badge */}
        <motion.div 
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.4, type: "spring" }}
          className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6"
        >
          <div className="relative">
            <div className="absolute inset-0 bg-emerald-500 rounded-full blur-lg opacity-50" />
            <div className="relative w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-full flex items-center justify-center shadow-lg border-2 border-emerald-300/50">
              <Shield className="w-7 h-7 md:w-8 md:h-8 text-white fill-white/20" />
            </div>
          </div>
        </motion.div>
      </motion.div>
      
      {/* Decorative elements */}
      <div className="absolute top-8 right-8 w-2 h-2 bg-primary rounded-full animate-pulse" />
      <div className="absolute bottom-12 left-12 w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse delay-300" />
      <div className="absolute top-1/3 left-8 w-1 h-1 bg-blue-400 rounded-full animate-pulse delay-500" />
    </div>
  );
}
